/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_DragInputs */

const cs_builder_drag = /** @type {(inputs: Builder_DragInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přetáhněte pro změnu pořadí`)
};

const en_builder_drag = /** @type {(inputs: Builder_DragInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag to reorder`)
};

/**
* | output |
* | --- |
* | "Drag to reorder" |
*
* @param {Builder_DragInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_drag = /** @type {((inputs?: Builder_DragInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_DragInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_drag(inputs)
	return cs_builder_drag(inputs)
});